export const AUDACITY_SITE_URL = 'https://www.audacityteam.org/'

export const AUDACITY_MUSEHUB_DOWNLOAD_URL =
    'https://www.musehub.com/app/audacity?utm_source=referral&utm_medium=audio-com-web&utm_campaign=audio-com-get-audacity-mh'
